// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string, oneOfType } from 'prop-types'
import DataRow from './DataRow'

// this is a tbody

const DataContainer = props => {
  const {
    columns,
    data,
    handleRowClick,
    rowClass,
    uniqueKey,
  } = props

  return (
    <tbody>
      {
        data.map((d, i) => (
          <DataRow
            key={uniqueKey ? d[uniqueKey] : i}
            columns={columns}
            rowData={d}
            handleRowClick={handleRowClick}
            rowClass={rowClass}
            uniqueKey={uniqueKey || i} />
        ))
      }
    </tbody>
  )
}

DataContainer.propTypes = {
  columns: array.isRequired,
  data: array.isRequired,
  handleRowClick: func,
  rowClass: oneOfType([
    func,
    string,
  ]),
  uniqueKey: string,
}

export default DataContainer
